<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/debito"><img :src="icBack" /></router-link>
        <span>Débito Veicular</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>

      <div class="content">
        <p>
          Olá<span v-if="clienteNome" id="cliente-nome">, {{ clienteNome }}</span>
          <small>Consulte abaixo e selecione os seus débitos veiculares que gostaria de pagar.</small>
        </p>

        <div class="info">
          <span class="badge">Débitos</span>

          <div class="list" v-if="debitos.length">
            <div class="scroll">
              <div v-for="debito in debitos" :key="debito.id" class="item">
                <input type="checkbox" :checked="debito.selected" :disabled="debito.disabled"
                  @click="toggleDebito(debito)" />

                <!-- <label>{{ debito.descricao }}</label> -->
                <label v-html="debito.descricao"></label>
                <small>R$ {{ Number(debito.valor || 0).toFixed(2) }}</small>
              </div>
            </div>

            <div class="total">
              <p>Total: <small>R$ {{ totalDebitosFormatted }}</small></p>
            </div>
          </div>

          <div v-else class="warning">
            <p>
              <small>Você não possui débitos pendentes.</small>
            </p>
          </div>
        </div>

        <router-link to="/debito/dados-debito-veicular" v-if="debitos.length" class="router-link">
          <img :src="next" class="nextStep" :class="{ disabled: !isAnyDebitoSelected }"
            @click.prevent="isAnyDebitoSelected && goToNextStep()" />
        </router-link>
      </div>

      <FooterGlobal />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icNext from '@/assets/svg/ic-next.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icBack from '@/assets/svg/ic-back.svg'
import FooterGlobal from '@/components/Footer.vue'
import { timerToReturnToHome } from '../../helper/timer'

export default defineComponent({
  name: 'SelecaoDebitoVeicular',
  components: {
    FooterGlobal,
  },
  data() {
    timerToReturnToHome(40000)
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      debitos: [],
      totalDebitos: 0,
      clienteNome: '',
    }
  },
  computed: {
    totalDebitosFormatted() {
      return this.totalDebitos.toFixed(2)
    },
    isAnyDebitoSelected() {
      return this.debitos.some((debito) => debito.selected)
    },
  },
  created() {
    this.fetchDebitos()
  },
  methods: {
    montarDescricao(item) {

      const mapeamentoTaxas = {
        'IPVA': 'IPVA',
        'LICENSING': 'Licenciamento',
        'FINE': 'Multa'
      };

      const mapeamentoCotas = {
        'SINGLE': '',
        'SINGLE_WITH_DISCOUNT': 'Cota Única com Desconto'
      };

      const tipo = mapeamentoTaxas[item.taxType] || item.taxType;
      const quota = mapeamentoCotas[item.quotaType] || '';


      const ano = item.exerciseYear ? ` ${item.exerciseYear}` : ''
      const vencimento = item.dueDate
        ? `<br>Vencimento: ${item.dueDate}`
        : ''

      return `${tipo}${ano} ${quota}${vencimento}`.trim()
    },

    fetchDebitos() {
      try {
        const raw = sessionStorage.getItem('dadosConsultaRenavam')
        console.log('dadosConsultaRenavam (raw):', raw)

        if (!raw) {
          console.warn('Nenhum dado encontrado no sessionStorage')
          this.debitos = []
          return
        }

        const consulta = JSON.parse(raw)
        console.log('consulta parseada:', consulta)

        const lista = consulta?.dados?._content


        if (!Array.isArray(lista) || lista.length === 0) {
          console.warn('Lista de débitos vazia ou estrutura diferente')
          this.debitos = []
          return
        }

        // Só mostra IPVA se for Cota Única (SINGLE e SINGLE_WITH_DISCOUNT), mas mantém outros tipos de débitos 
        const listaFiltrada = lista.filter((item) => {
          if (item.taxType === 'IPVA') {
            return item.quotaType === 'SINGLE' || item.quotaType === 'SINGLE_WITH_DISCOUNT'
          }
          return true
        })

        this.debitos = listaFiltrada.map((item, index) => ({
          id: index,
          descricao: this.montarDescricao(item),
          valor: Number(item.value) || 0,
          selected: false,
          disabled: false,

          // base
          taxType: item.taxType,
          quotaType: item.quotaType,
          exerciseYear: item.exerciseYear,
          dueDate: item.dueDate,
          renavam: item.renavam,
          licensePlate: item.licensePlate,
          stateAbbreviation: item.stateAbbreviation,
          owner: item.owner,
          value: Number(item.value) || 0, 

        
          ticketNumber: item.ticketNumber ?? null,
          infractionNoticeNumber: item.infractionNoticeNumber ?? null,
          violationCode: item.violationCode ?? null,
          violationDescription: item.violationDescription ?? null,
          segmentCode: item.segmentCode ?? null,
          stateSource: item.stateSource ?? null,
          infractionDate: item.infractionDate ?? null,
          isLicensingMandatory: item.isLicensingMandatory ?? false,
          issuingAuthorityCode: item.issuingAuthorityCode ?? null,

          dependentes: [],
          codigoDependencia: null,
        }))

        this.totalDebitos = 0

        const primeiro = listaFiltrada[0]
        if (primeiro?.owner) {
          this.clienteNome = primeiro.owner
          sessionStorage.setItem('clienteNome', primeiro.owner)
        }
        if (primeiro?.stateAbbreviation) {
          sessionStorage.setItem('clienteVeiculo', primeiro.stateAbbreviation)
        }
        if (primeiro?.licensePlate) {
          sessionStorage.setItem('placaVeiculo', primeiro.licensePlate)
        }

        console.log('Débitos mapeados:', this.debitos)
      } catch (error) {
        console.error('Erro ao carregar débitos:', error)
        this.debitos = []
      }
      this.aplicarRegraLicenciamento()
    },
    
    temIpvaNaLista() {
      return this.debitos.some((d) => d.taxType === 'IPVA')
    },

    aplicarRegraLicenciamento() {
      const temIpva = this.temIpvaNaLista()

      this.debitos.forEach((d) => {
        if (d.taxType === 'LICENSING') {
          // Com IPVA na lista: não deixa marcar licenciamento
          d.disabled = temIpva
          if (temIpva) {
            d.selected = false
          }
        }
      })
    },

    toggleDebito(debito) {
      if (debito.taxType === 'LICENSING' && this.temIpvaNaLista()) {
        return
      }
      if (debito.disabled && debito.taxType === 'LICENSING') {
        return
      }

      debito.selected = !debito.selected

      // (mantém dependentes se no futuro usar)
      if (debito.dependentes && debito.dependentes.length > 0) {
        debito.dependentes.forEach((dep) => {
          this.debitos.forEach((d) => {
            if (dep == d.codigoDependencia) {
              d.selected = debito.selected
              d.disabled = debito.selected
            }
          })
        })
      }

      this.aplicarRegraLicenciamento()

      this.totalDebitos = this.debitos.reduce((total, deb) => {
        return deb.selected ? total + parseFloat(deb.valor) : total
      }, 0)

      const debitosSelecionados = this.debitos.filter((deb) => deb.selected)
      sessionStorage.setItem('debitosSelecionados', JSON.stringify(debitosSelecionados))
      sessionStorage.setItem(
        'totalDebito',
        JSON.stringify({ totalDebitos: this.totalDebitos.toFixed(2) }),
      )
    },

    goToNextStep() {
      this.$router.push('/debito/dados-debito-veicular')
    },
  },
})
</script>